export default __webpack_public_path__ + "static/media/greatnews-post.c4aa31ce.svg";